import React, { useEffect, useRef, useState } from "react";

type Props = {
  sidebar: boolean;
  setSidebar: React.Dispatch<React.SetStateAction<boolean>>;
};

const useResizeSidebar = ({ sidebar, setSidebar }: Props) => {
  const rightSidebarRef = useRef(null);
  const [lastSize, setLastSize] = useState(55);

  const handleSidebarDisplay = () => {
    setSidebar((prev) => !prev);
  };

  const handleDragging = () => {
    setLastSize((rightSidebarRef.current as any).getSize());
  };

  useEffect(() => {
    if (!sidebar) {
      (rightSidebarRef.current as any).collapse();
    } else {
      console.log(lastSize);
      (rightSidebarRef.current as any).resize(lastSize);
    }
  }, [sidebar]);

  return {
    rightSidebarRef,
    lastSize,
    handleSidebarDisplay,
    handleDragging,
  };
};

export default useResizeSidebar;
